import React, { useEffect } from "react";

const QuotationDetails = ({
  quotationData,
  error,
  firmData,
  handleChange,
  cityList,
  stateList,
}) => {
  return (
    <div className="row">
      <div className="col-12 col-md-6 col-xl-4">
        <div className="input-block local-forms">
          <label>
            Firm <span className="login-danger">*</span>
          </label>

          <select
            className="form-select"
            value={quotationData.firm_id}
            disabled
            onChange={(e) => handleChange(null, "firm_id", e.target.value)}
          >
            <option value="">Select Firm</option>
            {firmData?.map((e) => (
              <option key={e._id} value={e._id}>
                {e.name}
              </option>
            ))}
          </select>

          {error.firm_id && (
            <small className="text-danger">{error.firm_id}</small>
          )}
        </div>
      </div>

      <div className="col-12 col-md-6 col-xl-4">
        <div className="input-block local-forms">
          <label>
            Date <span className="login-danger">*</span>
          </label>
          <input
            className={`form-control ${error.date ? "is-invalid" : ""}`}
            type="date"
            value={quotationData.estimate_details.date}
            onChange={(e) =>
              handleChange("estimate_details", "date", e.target.value)
            }
          />
          {error.date && <small className="text-danger">{error.date}</small>}
        </div>
      </div>

      <div className="col-12 col-md-6 col-xl-4">
        <div className="input-block local-forms">
          <label>
            Party Name <span className="login-danger">*</span>
          </label>
          <input
            className={`form-control ${error.party_name ? "is-invalid" : ""}`}
            type="text"
            placeholder="Enter party name"
            value={quotationData.estimate_party_data.name}
            onChange={(e) =>
              handleChange("estimate_party_data", "name", e.target.value)
            }
          />
          {error.party_name && (
            <small className="text-danger">{error.party_name}</small>
          )}
        </div>
      </div>

      <div className="col-12 col-md-6 col-xl-4">
        <div className="input-block local-forms">
          <label>Vendor Code</label>
          <input
            className="form-control"
            type="text"
            placeholder="Enter vendor code"
            value={quotationData.estimate_details.vender_code}
            onChange={(e) =>
              handleChange("estimate_details", "vender_code", e.target.value)
            }
          />
        </div>
      </div>

      <div className="col-12 col-md-6 col-xl-4">
        <div className="input-block local-forms">
          <label>Supply Place</label>
          <input
            className="form-control"
            type="text"
            placeholder="Enter supply place"
            value={quotationData.estimate_details.supply_place}
            onChange={(e) =>
              handleChange("estimate_details", "supply_place", e.target.value)
            }
          />
        </div>
      </div>
      <div className="col-12 col-md-6 col-xl-4">
        <div className="input-block local-forms">
          <label>GSTIN</label>
          <input
            className="form-control"
            type="text"
            placeholder="Enter GST No"
            value={quotationData.estimate_party_data.gst_no}
            onChange={(e) =>
              handleChange("estimate_party_data", "gst_no", e.target.value)
            }
          />
        </div>
      </div>

      <div className="col-12">
        <div className="input-block local-forms">
          <label>
            Address <span className="login-danger">*</span>
          </label>
          <textarea
            className={`form-control ${
              error.party_address ? "is-invalid" : ""
            }`}
            type="text"
            placeholder="Enter address"
            value={quotationData.estimate_party_data.address}
            onChange={(e) =>
              handleChange("estimate_party_data", "address", e.target.value)
            }
          />
          {error.party_address && (
            <small className="text-danger">{error.party_address}</small>
          )}
        </div>
      </div>

      <div className="col-12 col-md-6 col-xl-4">
        <div className="input-block local-forms">
          <label>
            State <span className="login-danger">*</span>
          </label>
          <select
            className={`form-select ${error.party_state ? "is-invalid" : ""}`}
            value={quotationData.estimate_party_data.state}
            onChange={(e) =>
              handleChange("estimate_party_data", "state", e.target.value)
            }
          >
            <option value="">Select State</option>
            {stateList?.map((state) => (
              <option key={state.isoCode} value={state.name}>
                {state.name}
              </option>
            ))}
          </select>
          {error.party_state && (
            <small className="text-danger">{error.party_state}</small>
          )}
        </div>
      </div>

      <div className="col-12 col-md-6 col-xl-4">
        <div className="input-block local-forms">
          <label>City</label>
          <select
            className="form-select"
            value={quotationData.estimate_party_data.city}
            onChange={(e) =>
              handleChange("estimate_party_data", "city", e.target.value)
            }
          >
            <option value="">Select City</option>
            {cityList?.map((city) => (
              <option key={city.name} value={city.name}>
                {city.name}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="col-12 col-md-6 col-xl-4">
        <div className="input-block local-forms">
          <label>Pincode</label>
          <input
            className="form-control"
            type="number"
            placeholder="Enter pincode"
            value={quotationData.estimate_party_data.pincode}
            onChange={(e) =>
              handleChange("estimate_party_data", "pincode", e.target.value)
            }
            maxLength="6"
          />
        </div>
      </div>
    </div>
  );
};

export default QuotationDetails;
